export const csvSamples = [
    {
        name: 'activity_user',
        path: `${process.env.PUBLIC_URL}/csvFiles/activity_user_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'bank_detail',
        path: `${process.env.PUBLIC_URL}/csvFiles/bank_detail_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'company_end_user',
        path: `${process.env.PUBLIC_URL}/csvFiles/company_end_user_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'end_user_address',
        path: `${process.env.PUBLIC_URL}/csvFiles/end_user_address_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'end_user_note',
        path: `${process.env.PUBLIC_URL}/csvFiles/end_user_note_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'product_sku_point',
        path: `${process.env.PUBLIC_URL}/csvFiles/product_sku_point_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'product_sku',
        path: `${process.env.PUBLIC_URL}/csvFiles/product_sku_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'project_end_user',
        path: `${process.env.PUBLIC_URL}/csvFiles/project_end_user_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'project_sku',
        path: `${process.env.PUBLIC_URL}/csvFiles/project_sku_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'user_mapping',
        path: `${process.env.PUBLIC_URL}/csvFiles/user_mapping_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'user_ledger',
        path: `${process.env.PUBLIC_URL}/csvFiles/user_ledger_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'bank_upload',
        path: `${process.env.PUBLIC_URL}/csvFiles/bank_upload_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'pan_upload',
        path: `${process.env.PUBLIC_URL}/csvFiles/pan_upload_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'redemption_catalouge',
        path: `${process.env.PUBLIC_URL}/csvFiles/redemption_catalouge_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'user_pincode',
        path: `${process.env.PUBLIC_URL}/csvFiles/user_pincode_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'upload-pincode',
        path: `${process.env.PUBLIC_URL}/csvFiles/user_pincode_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'voucher_coupon_code',
        path: `${process.env.PUBLIC_URL}/csvFiles/voucher_settlement.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'redemption_catalogue_offer',
        path: `${process.env.PUBLIC_URL}/csvFiles/redemption_catalogue_offer_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },

    {
        name: 'dispatch_upload',
        path: `${process.env.PUBLIC_URL}/csvFiles/dispatch_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'dispatch_upload36',
        path: `${process.env.PUBLIC_URL}/csvFiles/dispatch_evoucher_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'coupon_lucky_draw',
        path: `${process.env.PUBLIC_URL}/csvFiles/coupon_lucky_draw_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'dispatch_upload3',
        path: `${process.env.PUBLIC_URL}/csvFiles/courier_assign_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'dispatch_upload4',
        path: `${process.env.PUBLIC_URL}/csvFiles/AWB_assign_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'dispatch_upload6',
        path: `${process.env.PUBLIC_URL}/csvFiles/markpickup_assign_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'dispatch_upload8',
        path: `${process.env.PUBLIC_URL}/csvFiles/dispached_assign_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'dispatch_upload9',
        path: `${process.env.PUBLIC_URL}/csvFiles/Delivered_status_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'dispatch_upload2',
        path: `${process.env.PUBLIC_URL}/csvFiles/address_confirmation_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'service_area_pincode',
        path: `${process.env.PUBLIC_URL}/csvFiles/service_area_pincode.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },

    {
        name: 'vendor_pincode',
        path: `${process.env.PUBLIC_URL}/csvFiles/vendor_pincode.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'user_purchase_offer',
        path: `${process.env.PUBLIC_URL}/csvFiles/user_purchase_offer.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'user_ledger_offer',
        path: `${process.env.PUBLIC_URL}/csvFiles/user_ledger_offer.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'rrk_offer_skip_user',
        path: `${process.env.PUBLIC_URL}/csvFiles/rrk_offer_skip_user_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },

    {
        name: 'lead_call_upload',
        path: `${process.env.PUBLIC_URL}/csvFiles/lead_call_upload_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'consumer_survey_upload',
        path: `${process.env.PUBLIC_URL}/csvFiles/consumer_survey_upload.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'stock',
        path: `${process.env.PUBLIC_URL}/csvFiles/stock_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'user_class_mapping',
        path: `${process.env.PUBLIC_URL}/csvFiles/user_class_mapping_sample.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'update_purchase',
        path: `${process.env.PUBLIC_URL}/csvFiles/update_purchase.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
    {
        name: 'office_primary_user_mapping',
        path: `${process.env.PUBLIC_URL}/csvFiles/office_primary_user_mapping.csv`,
        description: "Two-factor authentication adds an extra layer of security to your account. To log in, in addition you'll need to provide a 6 digit code"
    },
];